import React from "react";
import { object } from "prop-types";

import { optionsType } from "../../../prop-types";
import { Col, Row } from "reactstrap";
import "./buttonSelectType.css";
import { LegalEntityIcon, NaturalPersonIcon } from "../../../assets";
import { ENTRY_TYPE } from "../../../features/watch-list-entry/constants/watchListEntryConstants";

const getValue = (options, field) => {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(field.value)
      ? field.value.indexOf(option.value) >= 0
      : field.value === option.value
  );
};

const FormikButtonSelectType = ({
  options,
  field,
  form: { setFieldValue },
  onChange,
}) => {
  const value = getValue(options, field);

  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    return setFieldValue(field.name, newValue);
  };

  const getClassName = (option) => {
    const base =
      "d-flex justify-content-between selectable-button-type-wl  align-items-center ";
    if (!value.length) {
      return base;
    }

    if (option.value === value[0].value) {
      return base + "active-selectable-button-type-wl ";
    }
    return base;
  };

  function RenderIcon({ optionValue }) {
    if (optionValue === ENTRY_TYPE.NATURAL_PERSON) {
      return <NaturalPersonIcon width={16} height={16} />;
    }

    if (optionValue === ENTRY_TYPE.LEGAL_ENTITY) {
      return <LegalEntityIcon width={16} height={16} />;
    }
  }

  return (
    <Row>
      {options.map((option, i) => {
        return (
          <Col key={i} lg={6} className={i % 2 === 0 ? "pr-2" : "pl-2"}>
            <div
              className={getClassName(option)}
              color="primary"
              onClick={() => handleChange(option)}
            >
              <RenderIcon optionValue={option.value} />
              <span>{option.label}</span>
              <div />
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

FormikButtonSelectType.propTypes = {
  options: optionsType.isRequired,
  form: object.isRequired,
  field: object.isRequired,
};

export default FormikButtonSelectType;



// WEBPACK FOOTER //
// ./src/components/formik/upsertWatchlistEntryForm/ButtonSelectType.jsx